"use client";

import { c as _c } from "react/compiler-runtime";
import { useInViewTracking } from "@/hooks/tracking/in-view/use-in-view-tracking.hook";
import { useJpmuid } from "@/hooks/tracking/jpmuid/use-jpmuid.hook";
import { useCookiebotConsent } from "@/vendors/Cookiebot/_hooks/use-cookiebot-consent.hook";
import { mapToSnowplowJobPayload } from "@/vendors/Snowplow/mappers/map-to-snowplow-job-payload";
type UseTrackJobAdInviewProps = {
  readonly jobAdId: number;
  readonly placement: string;
};
export function useTrackJobAdInview(t0) {
  const $ = _c(8);
  const {
    jobAdId,
    placement
  } = t0;
  const {
    jpmuid
  } = useJpmuid();
  const consent = useCookiebotConsent();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      threshold: 0.8
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== jobAdId || $[2] !== jpmuid || $[3] !== placement) {
    t2 = mapToSnowplowJobPayload({
      jobAdId,
      jpmuid,
      placement
    });
    $[1] = jobAdId;
    $[2] = jpmuid;
    $[3] = placement;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== consent || $[6] !== t2) {
    t3 = {
      intersectionObserverOptions: t1,
      model: {
        action: "Impression",
        category: "JobAd",
        consent,
        context: t2,
        hasTrackingEnabled: true
      }
    };
    $[5] = consent;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return useInViewTracking(t3);
}